import React, { Component } from 'react';

import styles from '../scss/Download.scss';
import RequestShapefiles from '../components/RequestShapefiles';
import RequestProfiles from '../components/RequestProfiles';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

export class RequestSelections extends Component {

    state = {
        activeTab: "profiles"
    };

    componentDidMount() {
        this.restoreSettings();
    }

    restoreSettings = () => {
        const activeTab = localStorage.getItem("ActiveRequestTab");
        if (activeTab) {
            this.setState({
                activeTab: activeTab
            });
        }
    }

    tabSelectionChange = (activeTab) => {
        if (activeTab) {
            this.setState({
                activeTab: activeTab
            });
        }
        localStorage.setItem("ActiveRequestTab", activeTab);
    }

    setIsBusyStatus = (isBusy) => {
        if (this.props.onIsBusyChange) {
            this.props.onIsBusyChange(isBusy);
        }
    }

    render() {
        return (
            <div className="request-container">

                <div className="request-container-header">
                    Select data to request:
                </div>
                <span className="request-data-notice-1">Note: Only data from TGLO CEPRA sponsored projects can be downloaded.</span>

                <div className="request-container-content">
                    <Tabs activeKey={this.state.activeTab} id="option-tabs" className="mb-3"
                        onSelect={this.tabSelectionChange}>
                        <Tab eventKey="profiles" title="Beach Profile Data">
                            <RequestProfiles isBusyChange={this.setIsBusyStatus} />
                        </Tab>
                        <Tab eventKey="shapefiles" title="Geospatial Data">
                            <RequestShapefiles isBusyChange={this.setIsBusyStatus} />
                        </Tab>
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default RequestSelections
